module.exports = __webpack_public_path__ + "static/02-67d2dc34272693c7110d26a9348fbeea.jpg";